export var GETPROFILEDETAILS = "GETPROFILEDETAILS";
export var UPDATE_ON_DESK_DETAILS = "UPDATE_ON_DESK_DETAILS";
export var UPDATE_PROFILE_IMAGE_DETAILS = "UPDATE_PROFILE_IMAGE_DETAILS";
export var RESET_PROFILE_DETAILS = "RESET_PROFILE_DETAILS";
